<div #legend resizeObserver (resize)="resizeLegend($event)" [caller]="'#legend'" class="legend" [ngStyle]="legendStyle()"></div>
